import React from 'react'
import ImageTest from '../components/test/ImageTest'

const ImageTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-blue-50 py-8">
      <ImageTest />
    </div>
  )
}

export default ImageTestPage